import React from "react";
import Loading from "../../components/shared/loading/Loading";
import useFetch from "../../hooks/useFetch";
import useSession from "../../hooks/useSession";
import { apiPath } from "../../utility/Constant";
import TeamCard from "./TeamCard";

const TeamListPage = () => {
  const { teamListApi } = apiPath;
  const [user, loading] = useSession();
  const [teamList, teamListLoading] = useFetch(teamListApi, true);
  if (teamListLoading | loading) {
    return <Loading />;
  }
  return (
    <div className="container mx-auto lg:pt-24 py-10 px-5 lg:px-16">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        <TeamCard />
        {teamList.map((member, index) => (
          <TeamCard key={index} member={member} user={user.role} />
        ))}
      </div>
    </div>
  );
};

export default TeamListPage;
